<template>
  <div class="activities">
    <h2>Wo wir aktiv sind</h2>
    <ul class="nav">
      <li v-for="(slide, index) in slides" :key="'nav_' + index">
        <button @click="changeSlide(index)" :class="{'active': current === index}">{{slide.title}}</button>
      </li>
    </ul>
    <div class="content-wrap">
      <div class="text-wrap">
        <div class="text-box" v-for="(slide, index) in slides" :key="'slide_' + index" :class="{'current': index === current}">
          <h3 v-html="slide.headline" />
          <p v-for="(p, i) in slide.paragraphs" :key="'p_' + i + 's_' + index" v-html="p" />
        </div>
      </div>
      <div class="map-wrap">
        <img
            v-for="(slide, index) in slides"
            :key="'img_' + index"
            :class="{'current': index === current}"
            :src="getImageUrl(slide.overlay)"
            alt="" >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProfileActivities",
    data() {
      return {
        current: 0,
        slides: [
          {
            title: 'Strom',
            headline: 'Strom für Geschäfts- und Privatkunden',
            paragraphs: [
              'Seit Frühjahr 2018 bieten wir Privatkundinnen und -kunden deutschlandweit Stromprodukte an, die sie mit 100 Prozent Ökostrom versorgen. Firmenkundinnen und -kunden beliefern wir schon seit 1998 im gesamten Bundesgebiet.'
            ],
            overlay: 'germany-empty.svg'
          },
          {
            title: 'Wärme',
            headline: 'Rundum-sorglos-Pakete für jeden Bedarf',
            paragraphs: [
              'Mit unseren Wärme-Angeboten bieten wir unseren Kundinnen und Kunden Rundum-sorglos-Pakete. Wir erneuern nicht nur die Heizungsanlage, sondern helfen ihnen, Monat für Monat Geld und Energie zu sparen. Dabei bieten wir eine große Anlagenauswahl – von Wärmepumpen über Übergabestationen für Fernwärme bis hin zu Gasbrennwertthermen.',
              'Kundinnen und Kunden in Hannover und der Region bieten wir zudem verschiedene attraktive Gastarife zur Auswahl. So ist für jeden der richtige dabei – ob online-affin, klassisch oder flexibel.'
            ],
            overlay: 'germany-empty.svg'
          },
          {
            title: 'Windkraft',
            headline: 'Deutschlandweites Engagement im Bereich der Binnenland-Windkraft',
            paragraphs: [
              'Als 100-prozentiges Tochterunternehmen von enercity engagiert sich die enercity Erneuerbare GmbH deutschlandweit im Bereich der Binnenland-Windkraft. Derzeit hat sie 23 Windparks im Eigenbetrieb und 53 Windparks in der Betriebsführung. Darüber hinaus entwickelt das Unternehmen im gesamten Bundesgebiet neue Windenergieprojekte.'
            ],
            overlay: 'germany-wind.svg'
          },
          {
            title: 'Photovoltaik',
            headline: 'Die Kraft der Sonne nutzen: Mit einer Photovoltaikanlage von enercity',
            paragraphs: [
              'Mit enercity Solar bietet enercity Kundinnen und Kunden in ganz Deutschland die Möglichkeit, ihren eigenen sauberen Strom zu erzeugen. Dabei können sie wählen, ob sie ihre Photovoltaikanlage kaufen oder pachten möchten.',
              'Erfolgreich aktiv sind wir auch im Bereich Mieterstrom: Über das staatlich geförderte Modell können Bewohnerinnen und Bewohner von Mehrfamilienhäusern ebenfalls vom Direktstrom aus Sonnenenergie profitieren.'
            ],
            overlay: 'germany-empty.svg'
          },
          {
            title: 'Wasser',
            headline: 'Gute Trinkwasserqualität zum fairen Preis',
            paragraphs: [
              'Mit rund 140 Jahren Erfahrung in der Wasseraufbereitung und durch umweltorientierte, nachhaltige Grundwasserwirtschaft garantiert enercity eine konstante und gute Trinkwasserqualität für rund 700.000 Menschen in Hannover und der Region.',
              'Dabei unterschreitet enercity Wasser die strengen Grenzwerte der Trinkwasserverordnung in allen Parametern. Und das zu fairen Preisen!'
            ],
            overlay: 'germany-nds.svg'
          },
          {
            title: 'Beleuchtung',
            headline: 'Effizientes Licht: Stadtbeleuchtung',
            paragraphs: [
              'In Hannover, Langenhagen, Seelze-Letter, Springe und Bremerhaven betreibt enercity die öffentliche Beleuchtung mit innovativer Technologie. Die Leuchttypen senken den Aufwand für Reparatur, Wartung und Logistik. Zudem sparen sie wertvolle Energie.'
            ],
            overlay: 'germany-nds.svg'
          },
          {
            title: 'E-Mobilität',
            headline: 'Strom tanken, Umwelt schonen – mit enercity',
            paragraphs: [
              'Privatkundinnen und -kunden, die auf Elektrofahrzeuge umsteigen wollen, unterstützen wir im gesamten Bundesgebiet bei der Beantragung von Fördermitteln. Außerdem liefern wir ihnen die perfekte Lademöglichkeit für ihr Zuhause.',
              'Darüber hinaus entwickeln wir Mobilitätslösungen für Firmen, die ihren Kundinnen und Kunden sowie Mitarbeitenden eine Stromtankstelle zum Laden ihrer Elektroautos anbieten oder gar ihren gesamten Fuhrpark auf Elektrofahrzeuge umrüsten möchten.'
            ],
            overlay: 'germany-empty.svg'
          }
        ]
      }
    },
    methods: {
      changeSlide(index) {
        this.current = index;
      },
      getImageUrl(name) {
        return require('../assets/' + name);
      }
    }
  }
</script>

<style scoped>
  .activities {
    position: relative;
    max-width: 1020px;
    margin: 0 auto;
    overflow: hidden;
  }
  h2 {
    font-size: 100px;
    font-weight: 700;
    text-align: center;
    margin: 0.2em;
    background: linear-gradient(90.02deg, #B1D995 1.4%, #3ABABA 90.79%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .nav {
    display: flex;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 3% -10px;
  }
  button {
    position: relative;
    font-size: 18px;
    font-weight: 500;
    font-family: inherit;
    color: #102D61;
    border: 0;
    padding: 10px;
    background-color: transparent;
    opacity: 0.3;
    transition: 0.3s ease;
    cursor: pointer;
  }
  button:after {
    content: "";
    position: absolute;
    display: block;
    left: 50%;
    right: 50%;
    height: 2px;
    bottom: 8px;
    background-color: #102D61;
    opacity: 0;
    transition: 0.3s ease;
    border-radius: 2px;
  }
  button:focus {
    outline: 0;
    padding: 10px;
    display: inline-block;
  }
  button:hover, button.active {
    opacity: 1;
  }
  button.active:after {
    opacity: 1;
    left: 10px;
    right: 10px;
  }
  .content-wrap {
    position: relative;
    display: flex;
  }
  .text-wrap {
    position: relative;
    display: block;
    flex: 1 1 50%;
    max-width: 50%;
    z-index: 1;
    width: 100%;
  }
  .text-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    opacity: 0;
    transition: 0.4s ease;
    transform: translate3d(0, 0, 0) scale(0.9);
  }
  .text-box.current {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
    transition: 0.4s ease 0.3s;
  }
  h3 {
    font-size: 36px;
    line-height: 1.3;
    margin: 1em -0.03em 0.4em;
  }
  .map-wrap {
    position: relative;
    display: block;
    flex: 1 1 50%;
    max-width: 50%;
    overflow: hidden;
    background: linear-gradient(120deg, #FF0000 0%, #990099 100%);
  }
  .map-wrap:after {
    content: "";
    position: relative;
    display: block;
    padding-top: 100%;
    background-image: url(../assets/germany.svg);
    background-size: 100%;
  }
  .map-wrap img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0;
    transition: 0.3s ease 0.2s;
  }
  .map-wrap img.current {
    opacity: 1;
    transition: 0.3s ease;
  }
  @media(max-width: 1199px) {
    .activities {
      margin: 0 34px calc(50px + 5%);
    }
    h2 {
      font-size: 62px;
    }
  }
  @media(max-width: 999px) {
    h3 {
      font-size: 24px;
    }
    p {
      font-weight: 400;
    }
    .map-wrap {
      max-width: 63%;
      flex: 1 1 63%;
      margin-left: -5%;
      margin-right: -8%;
    }
  }
  @media(max-width: 767px) {
    .activities {
      margin: 0;
      padding: 0 20px calc(40px + 5%);
    }
    h2 {
      font-size: 48px;
    }
    button {
      font-size: 16px;
    }
    .nav li {
      margin: -3px;
    }
    .nav {
      margin: 0 -20px;
      padding: 0 12px;
      overflow: auto;
      white-space: nowrap;
    }

    p {
      font-size: 14px;
    }
  }
  @media(max-width: 567px) {
    h2 {
      font-size: 32px;
    }
    .nav:after {
      content: ".";
      min-width: 20px;
      opacity: 0;
    }
    .content-wrap {
      flex-direction: column;
    }
    .map-wrap {
      order: -1;
      margin: 7% auto 2%;
      max-width: 70%;
      min-width: 70%;
      left: -3%;
    }
    .text-wrap {
      max-width: 100%;
      flex: 1 1 100%;
    }
    .text-box.current {
      position: relative;
    }
  }
</style>